// src/Header.tsx

import React, { useState } from "react";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (!section) return;
    const headerHeight = window.innerWidth < 768 ? 80 : 96;
    // Pour "contact", le titre est au milieu — on scroll jusqu'au bord de la section
    if (id === 'contact') {
      const top = section.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    } else {
      const title = section.querySelector('h1, h2') as HTMLElement | null;
      const target = title || section;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 12;
      window.scrollTo({ top, behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header 
      className="w-full fixed top-0 left-0 text-white shadow-md z-50"
      style={{
        background: "linear-gradient(135deg, #000000 0%, #1a1a1a 20%, #2d2d2d 40%, #1a1a1a 60%, #0d0d0d 80%, #000000 100%)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
      }}
    >
      <meta name="description" content="LX Proto3D - Services de modélisation 3D, rendu et impression 3D pour vos projets personnels et professionnels." />
      <style>
        {`
          .nav-link {
            position: relative;
            padding: 0.4rem 0.75rem;
            border-radius: 8px;
            transition: all 0.3s ease;
            white-space: nowrap;
            cursor: pointer;
          }
          
          .nav-link::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
            border-radius: 8px;
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: -1;
          }
          
          .nav-link:hover::before {
            opacity: 1;
          }
          
          .nav-link:hover {
            transform: translateY(-2px);
          }

          @media (max-width: 768px) {
            .mobile-menu {
              position: fixed;
              top: 0;
              right: 0;
              height: 100vh;
              width: 70%;
              max-width: 300px;
              background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%);
              transform: translateX(100%);
              transition: transform 0.3s ease;
              padding: 6rem 2rem 2rem;
              box-shadow: -4px 0 20px rgba(0, 0, 0, 0.5);
              z-index: 100;
            }
            
            .mobile-menu.open {
              transform: translateX(0);
            }

            .hamburger {
              display: flex;
              flex-direction: column;
              gap: 5px;
              cursor: pointer;
              padding: 8px;
            }

            .hamburger span {
              width: 25px;
              height: 3px;
              background: white;
              border-radius: 2px;
              transition: all 0.3s ease;
            }

            .hamburger.open span:nth-child(1) {
              transform: rotate(45deg) translate(8px, 8px);
            }

            .hamburger.open span:nth-child(2) {
              opacity: 0;
            }

            .hamburger.open span:nth-child(3) {
              transform: rotate(-45deg) translate(7px, -7px);
            }
          }
        `}
      </style>
      <div className="flex items-center justify-between h-20 md:h-24 px-4 md:px-0">
        {/* Logo + Name */}
        <a 
          href="#hero" 
          className="flex items-center gap-2 md:gap-4 md:ml-8 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setMobileMenuOpen(false);
          }}
        > 
          <img
            src="/Logo.jpg"
            alt="Logo LX Proto3D"
            className="h-12 w-12 md:h-16 md:w-16 object-cover rounded"
          />
          <span className="text-2xl md:text-4xl font-heading tracking-wide">LX Proto3D</span>
        </a>

        {/* Desktop Navbar */}
        <nav className="hidden md:flex items-center gap-6 text-lg font-sans mr-8">
          <span className="nav-link" onClick={() => scrollToSection('about')}>À propos</span>
          <span className="nav-link" onClick={() => scrollToSection('services')}>Services</span>
          <span className="nav-link" onClick={() => scrollToSection('products')}>Produits</span>
          <span className="nav-link" onClick={() => scrollToSection('portfolio')}>Portfolio</span>
          <span className="nav-link" onClick={() => scrollToSection('contact')}>Contact</span>
        </nav>

        {/* Mobile Hamburger */}
        <div className="md:hidden mr-4">
          <div 
            className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Mobile Menu */}
        <nav className={`mobile-menu md:hidden ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="flex flex-col gap-6">
            <span className="nav-link text-xl" onClick={() => scrollToSection('about')}>À propos</span>
            <span className="nav-link text-xl" onClick={() => scrollToSection('services')}>Services</span>
            <span className="nav-link text-xl" onClick={() => scrollToSection('products')}>Produits</span>
            <span className="nav-link text-xl" onClick={() => scrollToSection('portfolio')}>Portfolio</span>
            <span className="nav-link text-xl" onClick={() => scrollToSection('contact')}>Contact</span>
          </div>
        </nav>

        {/* Overlay pour mobile */}
        {mobileMenuOpen && (
          <div 
            className="md:hidden fixed inset-0 bg-black/50 z-[-1]"
            onClick={() => setMobileMenuOpen(false)}
          />
        )}
      </div>
    </header>
  );
}